import { useState, useEffect,useContext } from 'react';
import { useNavigate,useParams } from 'react-router-dom';
import { Card, CardContent } from 'Assessment/src/components/ui/card';
import { Button } from 'Assessment/src/components/ui/button';
import { ScenarioCard } from 'Assessment/src/components/ScenarioCard';
import { AudioRecorder } from 'Assessment/src/components/AudioRecorder';
import { TranscriptCard } from 'Assessment/src/components/TranscriptCard';
import { RecordingInstructions } from 'Assessment/src/components/RecordingInstructions';
import { SuccessOverlay } from 'Assessment/src/components/SuccessOverlay';
import { useAssessmentSession } from 'Assessment/src/hooks/useAssessmentSession';
import { assessmentStt, assessmentValidate, assessmentUpdate, assessmentGet } from 'utils/assessmentApplication/assessmentService';
import { toast } from 'sonner';
import { createGamePlayHistory, activityUpdate } from 'utils/gameApplication/gameActivityService';
import { useColor } from "components/ui/ColorContext";
import { ScoreContext } from 'views/game/demoplay/GamePreview';
import { updatePreAssessmentBlock } from 'views/game/demoplay/common';

const PreTraining = ({ AssignId, Activitydata,seconds,
setActivitydata,formData, learnerPlayList, data, contentByLanguage, onComplete,currentQuestNo,questState }: {
  currentQuestNo?:any; 
  seconds?: any;
   Activitydata?:any;
 setActivitydata?:any;
  formData?: any, 
  learnerPlayList?: any,
  data?: any,
  AssignId?:any;
  contentByLanguage?: string | null;
    onComplete?: () => void;
    questState?:any;
} = {}) => {
  const { learner_game_play_id } = useParams();
   const { profile, setProfile,setlearnerActivityrec,deviceInfo } = useContext(ScoreContext);
  const navigate = useNavigate();
  const { session, loading, loadSession, } = useAssessmentSession(formData, learnerPlayList,currentQuestNo);
const { primaryColor } = useColor();
  // Recording state
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
  const [transcript, setTranscript] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const [isValid, setIsValid] = useState<boolean | undefined>(undefined);
  const [validationMessage, setValidationMessage] = useState('');

  // Processing state
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [processingProgress, setProcessingProgress] = useState(0);
  const [processingStage, setProcessingStage] = useState<'transcribing' | 'validating' | 'saving'>('transcribing');

  // UI state
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);
  const [isCurrentlyRecording, setIsCurrentlyRecording] = useState(false);

  useEffect(() => {
    loadSession();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleRecordingComplete = (blob: Blob) => {
    setAudioBlob(blob);
  };

  const handleRecordingStop = (blob: Blob) => {
   
    setAudioBlob(blob);
    processRecording(blob);
  };

  const buildAttemptEntry = (
    attemptNumber: number,
    transcriptText: string,
    isValidEntry: boolean,
    validationMsg: string,
  ) => ({
    attempt: attemptNumber,
    is_valid: isValidEntry,
    timestamp: new Date().toISOString(),
    transcript: transcriptText,
    validation_message: validationMsg,
  });

  const normalizeAttemptHistory = (attempts: any) => {
    if (Array.isArray(attempts)) return attempts;

    if (typeof attempts === 'string') {
      const candidates = [attempts];
      let current = attempts.trim();

      // Some records were saved as repeatedly stringified JSON. Peel those layers back.
      while (current.startsWith('"') && current.endsWith('"')) {
        try {
          current = JSON.parse(current);
          candidates.push(current);
        } catch {
          break;
        }
      }

      try {
        const parsed = JSON.parse(current);
        if (Array.isArray(parsed)) return parsed;
      } catch {
        // Fall through to the raw string wrapper below.
      }

      return candidates;
    }

    return [];
  };

  const getAttemptHistory = (record: any) => {
    const history = record?.pre_transcript_attempts
      ?? record?.assessmentPreTranscriptAttempts
      ?? record?.updatedData?.pre_transcript_attempts
      ?? record?.updatedData?.assessmentPreTranscriptAttempts;

    return normalizeAttemptHistory(history);
  };

  const validationPrompt =
    data?.ValidationPrompt
    ?? formData?.ValidationPrompt
    ?? learnerPlayList?.ValidationPrompt;



const processRecording = async (audioBlob: Blob): Promise<boolean> => {
    if (!session) return false;

    setIsProcessing(true);
    setProcessingProgress(0);
    setProcessingStage('transcribing');

    try {
      // Step 1: Convert audio blob to base64
      setProcessingProgress(5);
      const reader = new FileReader();
      const base64Audio = await new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          const base64 = (reader.result as string).split(',')[1];
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(audioBlob);
      });
      setProcessingProgress(20);

      // Step 2: STT
      const sttResponse = await assessmentStt({
        audio: base64Audio,
        gameId: session.gameId,
        phase: 'pre'
      });
      setProcessingProgress(50);

      // Check if STT API returned 500
      const isSttFailed = sttResponse?.status === 500;
      if (sttResponse?.error) throw new Error(sttResponse.error.message);

      const sttData = sttResponse?.data ?? sttResponse;
      // const transcriptText = String(sttData?.transcript.trim() ?sttData?.transcript: 'You dont record anything');
      const transcriptText = isSttFailed ? "api failed" : String(sttData?.transcript?.trim() ? sttData.transcript : "You don't record anything");
      // const transcriptText = String(sttData?.transcript ?? '');
      const word_count = Number(sttData?.word_count ?? 0);

      // Check for minimum word count
      if (word_count < 10) {
        const message = `Your response is too short (${word_count} words). Please provide at least 10 words.`;

        setTranscript(transcriptText);
        setWordCount(word_count);
        setIsValid(false);
        setValidationMessage(message);
        const newAttempts = attempts + 1;
        setAttempts(newAttempts);
 setlearnerActivityrec((prev:any)=>
          updatePreAssessmentBlock(
            prev,
            {
              blockId:data.blockId,
              attempt:newAttempts,
              transcript:transcriptText,
              is_valid:false,
              validation_message:message
            },
            deviceInfo
          )
        );
        // Fetch existing attempts and save to DB
       
        const assessmentIdToUse = session.assessmentId;
        const existingData = (await assessmentGet(assessmentIdToUse))?.updatedData;
       

        const nextAttemptEntry = buildAttemptEntry(
          // newAttempts, transcriptText, false, message
          newAttempts,
          isSttFailed ? "STT service unavailable" : transcriptText,
          false,
          isSttFailed ? "STT service unavailable" : message

        );
        const existingAttempts = getAttemptHistory(existingData);
        const newAttemptsArray = [...existingAttempts, nextAttemptEntry];

        const shortUpdateResult = await assessmentUpdate({
          pre_transcript: transcriptText,
          pre_valid: false,
          assessmentPreValid: false,
          pre_attempts: newAttempts,
          pre_transcript_attempts: newAttemptsArray,
          assessmentPreTranscriptAttempts: newAttemptsArray,
        }, assessmentIdToUse);
        
        if (shortUpdateResult?.status === 'Error') {
          console.error('Failed to save short pre transcript:', shortUpdateResult);
          toast.error('Transcript was transcribed but could not be saved.');
        }
                let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
            const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        galAssignedId:AssignId,
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        gameId: learner_game_play_id,
        galTimeSpent: seconds,
      };
            const actId1 = Activitydata;
                const datas = JSON.stringify(updatedata)
                const activityResult = await activityUpdate(datas, actId1);

        // Create separate histData for this response
        const histData: any = {
          // histActivityId: session.assessmentId,
          histActivityId: activityResult?.updatedData?.galId,
          histGameId: session.gameId,
          histQuestNo: currentQuestNo,
          // histBlockId: session.assessmentId,
           histBlockId: activityResult?.updatedData?.galBlockId,
          histType: 'PreAssessment',
          histNavigateTo: 'retry',
          histOption: null as string | null,
          // histScore: 0,
          // histPreAssessmentScore: 0
        };
        
        if (newAttempts === 1) {
          histData.histpreassessmentresponse1 = transcriptText;
        } else if (newAttempts === 2) {
          histData.histpreassessmentresponse2 = transcriptText;
        } else if (newAttempts === 3) {
          histData.histpreassessmentresponse3 = transcriptText;
        }
        
        try {
          const historyResult = await createGamePlayHistory(JSON.stringify(histData));
       
        } catch (histError) {
          console.error('Failed to create short response history:', histError);
        }

        if (newAttempts >= 3) {
          setShowSubmitButton(true);
          setTimeout(() => handleSubmit(), 1500);
        }

        setIsProcessing(false);
        setProcessingProgress(0);
        return false;
      }

      setTranscript(transcriptText);
      setWordCount(word_count);

      // Step 3: Validation
      setProcessingStage('validating');
      setProcessingProgress(60);
     
      const validateResponse = await assessmentValidate({ 
        gameId: session.gameId, 
        phase: 'pre', 
        transcript: transcriptText,
        data: { ValidationPrompt: validationPrompt }
      });
      setProcessingProgress(75);

      if (validateResponse.error) throw new Error(validateResponse.error.message);

      const validationResult = validateResponse?.data ?? validateResponse;
      const valid = validationResult.valid === true;
      const validationMsg = valid
        ? validationResult.validation_comment || 'Great job!'
        : validationResult.correction_nudge || 'Please try to provide more specific feedback.';

      setIsValid(valid);
      setValidationMessage(validationMsg);

      const newAttempts = attempts + 1;
      setAttempts(newAttempts);
  setlearnerActivityrec((prev:any)=>
        updatePreAssessmentBlock(
          prev,
          {
            blockId:data.blockId,
            attempt:newAttempts,
            transcript:transcriptText,
            is_valid:valid,
            validation_message:validationMsg
          },
          deviceInfo
        )
      );
   
        const assessmentIdToUse = session.assessmentId;
        const existingData = (await assessmentGet(assessmentIdToUse))?.updatedData;
       

        const existingAttempts = getAttemptHistory(existingData);
        const newAttemptsArray = [...existingAttempts, buildAttemptEntry(newAttempts, transcriptText, valid, validationMsg)];

      // Save to database
      setProcessingStage('saving');
      setProcessingProgress(85);
      const assessmentResult = await assessmentUpdate({
        pre_transcript: transcriptText,
        pre_valid: Boolean(valid),
        assessmentPreValid: Boolean(valid),
        pre_attempts: newAttempts,
        pre_transcript_attempts: newAttemptsArray,
        assessmentPreTranscriptAttempts: newAttemptsArray,
        }, assessmentIdToUse);
     
      if (assessmentResult?.status === 'Error') {
        console.error('Failed to save pre transcript:', assessmentResult);
        toast.error('Transcript was transcribed but could not be saved.');
        throw new Error(assessmentResult.message);
      }
                let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
            const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        galAssignedId:AssignId,
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        gameId: learner_game_play_id,
        galTimeSpent: seconds,
      };
            const actId1 = Activitydata;
                const datas = JSON.stringify(updatedata)
                const activityResult = await activityUpdate(datas, actId1);

      // Create separate histData for this response
      const histData: any = {
        histActivityId:  activityResult?.updatedData?.galId,
        histGameId: session.gameId,
        histQuestNo: currentQuestNo,
        histBlockId: activityResult?.updatedData?.galBlockId,
        histType: 'PreAssessment',
        histNavigateTo: valid ? 'post_training' : 'retry',
        histOption: null as string | null,
        // histScore: valid ? 100 : 0,
        // histPreAssessmentScore: valid ? 10 : 0
      };
      
      if (newAttempts === 1) {
        histData.histpreassessmentresponse1 = transcriptText;
      } else if (newAttempts === 2) {
        histData.histpreassessmentresponse2 = transcriptText;
      } else if (newAttempts === 3) {
        histData.histpreassessmentresponse3 = transcriptText;
      }
      
      try {
        const historyResult = await createGamePlayHistory(JSON.stringify(histData));
      
      } catch (histError) {
        console.error('Failed to create assessment history:', histError);
      }

      setProcessingProgress(100);

      if (valid || newAttempts >= 3) {
        setShowSubmitButton(true);

        if (newAttempts >= 3) {
          setTimeout(() => handleSubmit(), 1500);
        }
      } else {
        setShowSubmitButton(false);
        toast.info('Please review the feedback and try again.');
      }

      return valid;
    } catch (error) {
      console.error('Error processing recording:', error);
      toast.error('Failed to process recording');
      return false;
    } finally {
      setIsProcessing(false);
      setTimeout(() => setProcessingProgress(0), 500);
    }
  };

  const handleSubmit = () => {
    if (!session) return;

  
    setShowSubmitButton(false);
    setValidationMessage('');
    setShowSuccessOverlay(true);
    onComplete?.(); // Notify parent immediately - Next button shows right away
    
    // Dispatch custom event to mark PreAssessment as completed globally
    window.dispatchEvent(new CustomEvent('preAssessmentComplete'));
    
    // Popup stays visible until user clicks Next button (no auto-close)
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background-start to-background-end flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background-start to-background-end relative">
      <div className="max-w-7xl mx-auto">
        <div className="min-h-[calc(100vh-22rem)] flex items-start md:items-center">
          <div className="grid md:grid-cols-2 gap-6 w-full">
            <div className="space-y-4">
              <ScenarioCard data={data} type={"pre"} contentByLanguage={contentByLanguage} />
              <RecordingInstructions />
            </div>

            <div className="space-y-6">
              <AudioRecorder
                maxDuration={120}
                hideRerecord={isValid === true}
                onRecordingComplete={handleRecordingComplete}
                onStopRecording={handleRecordingStop}
                onRecordingStart={() => setValidationMessage('')}
                onRecordingStateChange={(recording) => setIsCurrentlyRecording(recording)}
                disabled={isProcessing || isSubmitting}
                attemptCount={attempts}
                isValidating={isProcessing}
              />

              <TranscriptCard
                transcript={transcript}
                wordCount={wordCount}
                isValid={isValid}
                validationMessage={validationMessage}
                isProcessing={isProcessing}
                processingStage={processingStage}
                attemptCount={attempts}
                maxAttempts={3}
                processingProgress={processingProgress}
              />


<Button
  onClick={handleSubmit}
  className={` text-lg w-full !text-white disabled:!text-white ${
    showSubmitButton && !isProcessing && !isSubmitting && !isCurrentlyRecording
      ? 'dark:submit-glow-active'
      : ''
  }`}
  size="lg"
  disabled={!showSubmitButton || isProcessing || isSubmitting || isCurrentlyRecording}
  style={{
    // fontSize: "16px" ,
    background: primaryColor
      ? `linear-gradient(145deg,
          ${primaryColor} 0%,
          ${primaryColor}E6 30%,
          ${primaryColor}CC 70%,
          ${primaryColor} 100%
        )`
      : undefined,
    opacity:
      !showSubmitButton || isProcessing || isSubmitting || isCurrentlyRecording
        ? 0.5
        : 1,
  }}
  variant={isValid && showSubmitButton ? 'default' : 'secondary'}
>
                Submit Recording
</Button>

            
            </div>
          </div>
        </div>
      </div>

      <SuccessOverlay
        show={showSuccessOverlay}
        message="Thanks for your response! You’ll get insights at the end of the quest. Click on the Next button to continue."
        variant="success"
      />
    </div>
  );
};

export default PreTraining;
